import { useRouteMatch } from "react-router-dom";
import { FlowAddPayoutMethod } from "../../Settings/components/payout/FlowAddPayoutMethod";
import { OnboardingStep } from "../types";

export const PayoutMethod: React.FC<OnboardingStep> = ({ onNext }) => {
  const match = useRouteMatch();

  return <FlowAddPayoutMethod basePath={match.path} onNext={onNext} />;
};
